// Configuration for RBAC API testing
import { environment } from '../../environments/environment';
export const API_CONFIG = {
  // Backend URL - Update this to match your backend server
  BASE_URL: `${environment.controlplaneUrl}/manage`,
  
  // Localhost URL for invitations API
  LOCALHOST_URL: 'http://localhost:3000',
  

  // API timeout (in milliseconds)
  TIMEOUT: 10000,
  
  // Retry configuration
  MAX_RETRIES: 3,
  RETRY_DELAY: 1000,
};

// Helper function to get config with environment overrides
export const getConfig = () => {
  return {
    ...API_CONFIG,
    BASE_URL: `${environment.controlplaneUrl}/manage`,
    // BASE_URL: 'http://localhost:3000/analytics',
    ORGANISATION_ID: process.env.REACT_APP_ORGANISATION_ID || (typeof window !== 'undefined' ? localStorage.getItem('org_id') : null) || API_CONFIG.ORGANISATION_ID,
    USER_ID: process.env.REACT_APP_USER_ID || API_CONFIG.USER_ID,
  };
};

export default API_CONFIG; 